import {Component, Input} from '@angular/core';
import {FeatherIconNames} from 'feather-icons';
import {FeatherPipe} from '../../../core/pipes/feather.pipe';
import {CommonModule} from '@angular/common';

export type AlertStatusType = 'success' | 'danger' | 'warning' | 'info';
export type AlertStatusIconSize = 'small' | 'medium' | 'large';

@Component({
  selector: 'app-badge-status',
  imports: [
    CommonModule,
    FeatherPipe
  ],
  templateUrl: './badge-status.component.html',
  styleUrl: './badge-status.component.scss'
})
export class BadgeStatusComponent {

  @Input() typeTrue: AlertStatusType = 'success';
  @Input() typeFalse: AlertStatusType = 'danger';
  @Input() messageTrue: string = '';
  @Input() messageFalse: string = '';
  @Input() iconTrue: FeatherIconNames = 'check';
  @Input() iconFalse: FeatherIconNames = 'x';
  @Input() status: boolean = true;
  @Input() outline: boolean = false;
  @Input() iconSize: AlertStatusIconSize = 'small';

}
